import PropTypes from 'prop-types';

const COLOR_SCHEMA = {
  negative: {
    bg: '#FFF',
    primary: '#FFF',
    white: '#FFF',
    strokeProps: {
      stroke: '#000',
      strokeWidth: 2
    }
  },
  blue: {
    bg: '#C9E3F7',
    primary: '#FFF',
    white: '#0a0d77',
    strokeProps: {
      stroke: null,
      strokeWidth: null
    }
  },
  orange: {
    bg: '#C9E3F7',
    primary: '#FB6E44',
    white: '#F4EFED',
    strokeProps: {
      stroke: null,
      strokeWidth: null
    }
  }
};

const PrivateLandlord = ({ color = 'orange' }) => {
  const schema = COLOR_SCHEMA[color] ?? COLOR_SCHEMA.orange;
  return (
    <svg viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="52" cy="52" r="52" fill={schema.bg} />
      <path
        d="M23.8799 41.72V81.24H40.2302V62.987C40.2302 56.408 45.5107 51.0545 51.9999 51.0545C58.4891 51.0545 63.7696 56.408 63.7696 62.987V81.24H80.1199V41.72H23.8799Z"
        fill={schema.white}
        {...schema.strokeProps}
      />
      <path
        d="M80.1199 41.72L52.9372 41.72L23.8799 41.72L51.9999 17.4L80.1199 41.72Z"
        fill={schema.primary}
        {...schema.strokeProps}
      />
    </svg>
  );
};

PrivateLandlord.propTypes = {
  color: PropTypes.oneOf(['negative', 'blue', 'orange'])
};

export default PrivateLandlord;
